import React, { useState } from 'react';

export const FAQS = [
  {
    question: "¿Qué es el Anexo 24 y 30?",
    answer: "Son sistemas de control de inventarios para empresas con programas de fomento a la exportación, como IMMEX, que permiten cumplir con las obligaciones fiscales y aduaneras en México."
  },
  {
    question: "¿Cómo se integra la información con mis sistemas actuales?",
    answer: "Ofrecemos diversas opciones de integración, incluyendo carpetas FTP para transferencia masiva de archivos, conexiones por URL (APIs) para intercambio de datos en tiempo real, y layouts personalizados en Excel para carga de información."
  },
  {
    question: "¿Qué es el Expediente Digital VUCEM?",
    answer: "Es la recopilación y gestión de todos los documentos electrónicos relacionados con tus operaciones de comercio exterior, conforme a los requisitos de la Ventanilla Única de Comercio Exterior Mexicana (VUCEM), asegurando su disponibilidad y validez."
  },
  {
    question: "¿Ofrecen servicios de logística y transporte internacional?",
    answer: "Sí, coordinamos y gestionamos el transporte de tus mercancías a nivel nacional e internacional, abarcando modalidades terrestre, aérea y marítima, para asegurar una cadena de suministro eficiente."
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="preguntas" className="w-full py-12 md:py-24 lg:py-32 bg-gray-100 dark:bg-gray-900">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
            Preguntas Frecuentes
          </h2>
          <p className="max-w-[700px] text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
            Aquí resolvemos algunas de las dudas más comunes sobre nuestros servicios.
          </p>
        </div>
        <div className="mx-auto max-w-3xl py-12 space-y-4">
          {FAQS.map((faq, index) => (
            <div key={index} className="rounded-lg border border-gray-300 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900">
              <button
                className="flex w-full items-center justify-between p-4 text-left text-lg font-medium text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-respuesta-${index}`}
              >
                {faq.question}
                <span className="ml-auto">
                  {openIndex === index ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  )}
                </span>
              </button>
              {/* Always rendered (just hidden) so crawlers see the answers in the prerendered HTML. */}
              <div
                id={`faq-respuesta-${index}`}
                hidden={openIndex !== index}
                className="p-4 pt-0 text-gray-600 dark:text-gray-400"
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;